import React from 'react';

import { GlobalStateContext } from 'src/providers/GlobalStateProvider';

export const useGlobalState = () => {
  return React.use(GlobalStateContext);
};
